import api, {
  buildActivityScopeHeaders,
  buildCompanyScopeHeaders,
} from "./api";


function buildStudioPublicationScopeHeaders({
  companyUuid,
  activityUuid,
} = {}) {
  return {
    ...buildCompanyScopeHeaders(
      companyUuid
    ),

    ...buildActivityScopeHeaders(
      activityUuid
    ),
  };
}


function buildRequestConfig(
  scope
) {
  return {
    headers:
      buildStudioPublicationScopeHeaders(
        scope
      ),
  };
}


export const fetchCurrentStudioPublication = (
  documentId,
  {
    companyUuid,
    activityUuid,
  } = {}
) =>
  api.get(
    `/restaurant/studio/documents/${encodeURIComponent(documentId)}/publications/current`,
    buildRequestConfig({
      companyUuid,
      activityUuid,
    })
  );


export const fetchStudioPublication = (
  publicationId,
  {
    companyUuid,
    activityUuid,
  } = {}
) =>
  api.get(
    `/restaurant/studio/publications/${encodeURIComponent(publicationId)}`,
    buildRequestConfig({
      companyUuid,
      activityUuid,
    })
  );


export const listStudioPublications = (
  documentId,
  {
    companyUuid,
    activityUuid,
  } = {}
) =>
  api.get(
    `/restaurant/studio/documents/${encodeURIComponent(documentId)}/publications`,
    buildRequestConfig({
      companyUuid,
      activityUuid,
    })
  );


export const publishStudioLayoutVersion = (
  documentId,
  {
    versionId,
    metadata = {},
  },
  {
    companyUuid,
    activityUuid,
  } = {}
) =>
  api.post(
    `/restaurant/studio/documents/${encodeURIComponent(documentId)}/publications`,
    {
      versionId,
      metadata,
    },
    buildRequestConfig({
      companyUuid,
      activityUuid,
    })
  );


export const unpublishCurrentStudioPublication = (
  documentId,
  {
    companyUuid,
    activityUuid,
  } = {}
) =>
  api.delete(
    `/restaurant/studio/documents/${encodeURIComponent(documentId)}/publications/current`,
    buildRequestConfig({
      companyUuid,
      activityUuid,
    })
  );


export default Object.freeze({
  fetchCurrentStudioPublication,
  fetchStudioPublication,
  listStudioPublications,
  publishStudioLayoutVersion,
  unpublishCurrentStudioPublication,
});
